import { useEffect, useState } from 'react';

/**
 * Hook to detect when React hydration is complete
 * Prevents hydration mismatches by ensuring components render consistently
 * between server and client
 */
export function useHydration() {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    // This effect only runs on the client after hydration
    setIsHydrated(true);
  }, []);

  return isHydrated;
}

/**
 * Hook for components that need to render differently on server vs client
 * Returns true only after the component has hydrated on the client
 */
export function useIsClient() {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return isClient;
}

/**
 * Hook to safely access window object after hydration
 * Returns undefined during SSR and initial hydration
 */
export function useWindow() {
  const [windowObj, setWindowObj] = useState<Window | undefined>(undefined);

  useEffect(() => {
    setWindowObj(window);
  }, []);

  return windowObj;
}




